import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { ManagementPlanDTO } from './useGetManagementPlans';

export const useGetManagementPlan = (planId: string, options: { enabled?: boolean } = {}) => {
	return useQuery({
		queryKey: ['management-plan', planId],
		enabled: options.enabled ?? !!planId,
		queryFn: async () => {
			const { data } = await api.get<ManagementPlanDTO>(
				`/management/plan/findActivePlan/${planId}`
			);
			return data;
		},
	});
};
